<mat-form-field *transloco="let t" appearance="standard" class="w-100">
    <mat-label>{{ t('fields.number-value') }}</mat-label>
    <input matInput [formControl]="innerControl" type="number" [placeholder]="t('general.enter-value')" [attr.min]="args?.min" />
    <mat-error><td-validation-messages [control]="innerControl" [context]="{ name: key }"></td-validation-messages></mat-error>
</mat-form-field>
